import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Drawer, Select } from '@saas-kit/ui';

import type { QmsToken } from './types';
import type { WorkstationState } from './useWorkstation';

interface Props {
  open: boolean;
  token: QmsToken;
  ws: WorkstationState;
  onClose: () => void;
}

/** Move the counter's current token into another service's queue. */
export function TransferDialog({
  open,
  token,
  ws,
  onClose,
}: Props): JSX.Element {
  const { t } = useTranslation('qms');
  const [serviceId, setServiceId] = useState('');
  const options = ws.services.filter((s) => s.id !== token.service_id);

  return (
    <Drawer
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
      title={t('workstation.transfer.title')}
      footer={
        <Button
          disabled={!serviceId || ws.transfer.isPending}
          onClick={() =>
            ws.transfer.mutate(
              { tokenId: token.id, serviceId },
              { onSuccess: onClose },
            )
          }
        >
          {t('workstation.transfer.submit')}
        </Button>
      }
    >
      {options.length === 0 ? (
        <p className="text-sm text-muted-foreground">
          {t('workstation.transfer.empty')}
        </p>
      ) : (
        <label className="block space-y-1 text-sm">
          <span className="text-foreground">
            {t('workstation.transfer.field')}
          </span>
          <Select
            value={serviceId}
            onChange={(e) => setServiceId(e.target.value)}
          >
            <option value="">—</option>
            {options.map((service) => (
              <option key={service.id} value={service.id}>
                {service.name}
              </option>
            ))}
          </Select>
        </label>
      )}
    </Drawer>
  );
}
